import { render, staticRenderFns } from "./EditTextField.vue?vue&type=template&id=22a5dc0a&scoped=true"
import script from "./EditTextField.vue?vue&type=script&lang=ts"
export * from "./EditTextField.vue?vue&type=script&lang=ts"
import style0 from "./EditTextField.vue?vue&type=style&index=0&id=22a5dc0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a5dc0a",
  null
  
)

export default component.exports